export const SAVE_FRANCHISEE_DATA =
  'app/FranchiseDashboard/SAVE_FRANCHISEE_DATA';
